<template>
  <v-container fluid>
    <div class="mb-4">
      <h2>Artworks</h2>
    </div>
    <pre>{{ artworks }}</pre>
  </v-container>
</template>

<script>
import ArtworkApi from "@/api/customArtist/artwork";

export default {
  components: {
  },
  data() {
    return {
      artworks: []
    };
  },
  async created() {
    console.log('artworks')
    ArtworkApi.loadArtworks().then((result) => this.artworks=result.data)
   },
};
</script>
